import { render } from "./TrainDateHistoryCard.vue?vue&type=template&id=96f46bea&scoped=true"
import script from "./TrainDateHistoryCard.vue?vue&type=script&lang=js"
export * from "./TrainDateHistoryCard.vue?vue&type=script&lang=js"

import "./TrainDateHistoryCard.vue?vue&type=style&index=0&id=96f46bea&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f46bea"]])

export default __exports__